import { render, staticRenderFns } from "./KoioteImageSwitch.vue?vue&type=template&id=a0d1d42c&lang=es"
import script from "./KoioteImageSwitch.vue?vue&type=script&lang=js"
export * from "./KoioteImageSwitch.vue?vue&type=script&lang=js"
import style0 from "./KoioteImageSwitch.vue?vue&type=style&index=0&id=a0d1d42c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports